import { useEffect, useState } from "react";
import { Button } from "InnoUI/components";
import theme from "theme";
import { regexTypes } from "utils/config";
import { InputField } from "components";
import { useSelector } from "react-redux";
import { showAlert } from "utils/helper";
import BulkActionView from "InnoUI/components/BulkActionView";

import SC from "./style";
import ViewersDropdown from "./ViewersDropdown";
import { Checkbox } from "antd";
import { apiPost } from "api/callApi";

const SaveFilterModal = (props) => {
  const {
    onClose = () => {},
    openModalView,
    filters,
    searchQuery,
    projectId,
    type,
    fetchSavedFilters,
  } = props;

  console.log(filters, searchQuery, "filters");

  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState({
    filterName: "",
    viewer: "1",
    setAsDefault: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // return;
    try {
      setIsLoading(true);
      const result = await apiPost(`/v1/savedfilters`, {
        ...data,
        projectId,
        filters: JSON.stringify(filters),
        searchQuery,
        type,
      });

      setIsLoading(false);
      showAlert({ title: "Success", text: result?.message, icon: "success" });
      onClose();
      fetchSavedFilters(1);
      console.log(result, "result");
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const AddModalData = () => {
    return (
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper>
          <SC.LabelContainer>
            <SC.Label>
              Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <InputField
                  name="filterName"
                  value={data.filterName}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "10px",
                  }}
                  required
                  // regexType={regexTypes.textOnly}
                  // capitalize={true}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          <SC.LabelContainer>
            <SC.Label>Viewers</SC.Label>
            <SC.Children>
              <ViewersDropdown
                name="viewer"
                onChange={handleChange}
                defaultValue={data.viewer || "1"}
                width={"100%"}
              />
            </SC.Children>
          </SC.LabelContainer>
          <SC.LabelContainer>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
              }}
            >
              <Checkbox
                checked={data.setAsDefault}
                onChange={(e) => handleChange("setAsDefault", e.target.checked)}
              />
              <SC.Label style={{ fontSize: "15px", fontWeight: "normal" }}>
                Default for me
              </SC.Label>
            </label>
          </SC.LabelContainer>

          {/* Buttons */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "10px",
                height: "35px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={isLoading ? "Submitting..." : "Save"}
              type="submit"
              isLoading={isLoading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "35px",
                borderRadius: "10px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={"Save Filter"}
          openModal={openModalView}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            onClose();
            setData("");
          }}
          sx={{ borderRadius: "50px" }}
          borderRadius="20px"
        />
      )}
    </>
  );
};

export default SaveFilterModal;
